// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading-m {
  text-align: center;
  font-family: "General Sans";
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 57.6px */
}

.headingContainer {
  display: flex;
  width: 557px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

@media screen and (max-width: 650px) {
  .head {
    padding-left: 24px;
    padding-right: 24px;
    height: auto !important;
    margin-bottom: 0;
  }
  .headingContainer {
    margin-top: 20%;
  }
  .heading-m {
    text-align: center;
    font-family: "General Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 135%; /* 32.4px */
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing-page/components/hero-section/style.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAAJ;;AAGA;EAEI;IACI,kBAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EADN;EAIE;IACI,eAAA;EAFN;EAKE;IACI,kBAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,WAAA;EAHN;AACF","sourcesContent":["\n.heading-m{\n    text-align: center;\n    font-family: \"General Sans\";\n    font-size: 48px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 57.6px */\n}\n\n.headingContainer{\n    display: flex;\n    width: 557px;\n    flex-direction: column;\n    align-items: center;\n    gap: 40px;\n}\n\n@media screen and (max-width: 650px) {\n\n    .head{\n        padding-left: 24px;\n        padding-right: 24px;\n        height: auto !important;\n        margin-bottom: 0;\n    }\n\n    .headingContainer{\n        margin-top: 20%;\n    }\n\n    .heading-m{\n        text-align: center;\n        font-family: \"General Sans\";\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 135%; /* 32.4px */\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
